module.exports = __webpack_public_path__ + "static/media/footer-4.5c799124.svg";